<template>
  <ux-form
    ref="form"
    :data="formData"
    :rules="rules"
    width="600px"
    :colon="true"
    label-width="85px"
    data-automation="addUser"
  >
    <ux-form-item :label="$t('HT.addMsgTemp.name')" prop="name">
      <ux-input
        v-model.trim()="formData.name"
        :maxlength="30"
        :placeholder="$t('HT.addMsgTemp.placeholder1')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addMsgTemp.code')" prop="code">
      <ux-input
        v-model.trim()="formData.code"
        :disabled="formData.id ? true : false"
        :maxlength="50"
        :placeholder="$t('HT.addMsgTemp.placeholder2')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addMsgTemp.type')" prop="type">
      <ux-select
        v-model="formData.type"
        clearable
        :disabled="formData.id ? true : false"
        :options="$opt.tempType"
      ></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addMsgTemp.signId')" prop="sign_id" v-if="formData.type === 1 || formData.type === 0">
      <ux-select
        v-model="formData.sign_id"
        :props="props1"
        clearable
        :options="signOption"
      ></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addMsgTemp.content')" prop="content" start>
      <ux-input
        v-model.trim()="formData.content"
        type="textarea"
        show-word-limit
        :maxlength="100"
        resize="none"
        :autosize="{ minRows: 3, maxRows: 6 }"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addMsgTemp.channels')" prop="channels" start>
      <ux-select
        v-model="formData.channels"
        v-if="formData.type === 0 || formData.type === 1"
        multiple
        :props="props2"
        clearable
        :options="smsChannel"
      ></ux-select>
      <ux-select
        v-model="formData.channels"
        v-else-if="formData.type === 2"
        multiple
        :props="props2"
        clearable
        :options="ttsChannel"
      ></ux-select>
      <ux-select
        v-model="formData.channels"
        v-else
        multiple
        :props="props2"
        clearable
        :options="channelOption"
      ></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addMsgTemp.status')" prop="status">
      <ux-select v-model="formData.status" clearable :options="$opt.SmsStatus"></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addMsgTemp.tempId')" prop="temp_id">
      <ux-input v-model.trim()="formData.temp_id"></ux-input>
    </ux-form-item>
  </ux-form>
</template>
<script>
export default {
  props: {
    signOption: {
      //选择签名
      type: Array,
      default: () => {
        return [];
      }
    },
    channelOption: {
      //选择通道
      type: Array,
      default: () => {
        return [];
      }
    },
    data: {
      type: Object,
      default: () => {
        return {
          name: '', // 模板名
          code: '', // 模板Code
          type: '', // 模板类型
          sign_id: '', // 签名id
          content: '', // 内容
          description: '', // 描述
          status: '', // 模板审核状态
          channels: [], // 支持的通道
          temp_id: '' // 阿里云模板ID
        };
      }
    }
  },
  data() {
    return {
      props1: {
        value: 'id',
        label: 'name',
        disabled: 'disabled'
      },
      props2: {
        value: 'code',
        label: 'name',
        disabled: 'disabled'
      },
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.template(this),
      smsChannel: [], // 短信SSM通道
      ttsChannel: [], // 语音TTS通道
      filter: {
        // 查询参数
        name: '', // 分组名称
        page: 1,
        size: 10
      }
    };
  },

  created() {
    this.getChannels();
  },

  methods: {
    getChannels() {
      let sms = [];
      let tts = [];
      this.channelOption.map((item) => {
        if (item.type === 1) {
          sms.push(item);
        } else if (item.type === 2) {
          tts.push(item);
        }
        return {
          sms,
          tts
        };
      });
      this.smsChannel = sms;
      this.ttsChannel = tts;
    }
  }
};
</script>
